import { FC as ReactFC } from 'react';

import * as intl from 'react-intl-universal';
import {
  Badge,
  Button,
  Card,
  CardBody,
  CardFooter,
  CardText,
  CardTitle,
  Col,
} from 'reactstrap';

import { formatDate } from 'helpers/DateFormat';
import ImageComponent from 'shared/components/image/ImageComponent';
import DateFormatType from 'shared/enums/DateFormatType';

import styles from '../mfaMethods.module.scss';
import MfaMethodCardProps from './MfaMethodCardProps';

const MfaMethodCard: ReactFC<MfaMethodCardProps> = (
  props: MfaMethodCardProps
) => {
  const { method, disableSetupButton, onSetupNow, onDeactivate } = props;
  const {
    type,
    name,
    description,
    illustration,
    thumb,
    isActive,
    activatedOn,
  } = method;

  const activatedDate = activatedOn
    ? formatDate(activatedOn, DateFormatType.MfaActivatedOn)
    : null;

  return (
    <Col xl="6" className="mb-4 d-flex">
      <Card
        data-cy={`mfa-method-${String(type)}`}
        data-testid={`mfa-method-${String(type)}`}
        className={`overflow-hidden ${styles.mfaMethodCard} ${
          isActive ? styles.active : ''
        } flex-fill`}
        tabIndex={0}
      >
        <CardBody
          className={`position-relative align-items-start ${styles.mfaMethodCardBody}`}
        >
          {isActive && (
            <div className={styles.activationInfo}>
              <Badge
                color="light"
                pill
                className={`text-14-medium ${styles.mfaMethodBadge}`}
              >
                <span className="d-flex align-items-center justify-content-center">
                  <i className="icon-filled-check mr-2" />
                  {intl.get('LBL_MFA_METHODS_ACTIVATED_BADGE')}
                </span>
              </Badge>
              {activatedDate && (
                <small
                  className={`text-10-light mt-1 ${styles.mfaMethodActivationDate}`}
                >
                  {intl.get('LBL_MFA_METHODS_ACTIVATED_ON', {
                    date: activatedDate,
                  })}
                </small>
              )}
            </div>
          )}

          <ImageComponent
            loading="eager"
            src={illustration}
            className={`${styles.mfaMethodImg}`}
            alt={name}
            thumb={thumb}
          />
          <CardTitle
            tag="h5"
            className={`text-16-bold ${styles.mfaCardTitle} mb-2`}
          >
            {name}
          </CardTitle>
          <CardText
            className={`text-14-light text-gray ${styles.mfaCardDescription}`}
          >
            {description}
          </CardText>
        </CardBody>
        <CardFooter
          className={`d-flex justify-content-end ${styles.mfaMethodCardFooter}`}
        >
          {isActive ? (
            <Button className="btn btn-secondary" onClick={onDeactivate}>
              {intl.get('BTN_MFA_DEACTIVATE')}
            </Button>
          ) : (
            <Button
              className="btn btn-secondary"
              onClick={() => onSetupNow(method)}
              disabled={disableSetupButton}
            >
              {intl.get('BTN_MFA_SET_UP_NOW')}
            </Button>
          )}
        </CardFooter>
      </Card>
    </Col>
  );
};

export default MfaMethodCard;
